import React, { Component } from "react";
import SearchItemsList from "./SearchItemsList";

let optionList;
let take = 3;
let minQuerytoTrack = 3;

class AutoCompleteView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {
                name: ""
            },
            cursor: -1,
            searchItems: [],
        };
        this.trackSearchToGA = this.trackSearchToGA.bind(this);
        this.autocomplete = this.autocomplete.bind(this);
        this.hanldeKeyup = this.hanldeKeyup.bind(this);
        this.hanldeKeydown = this.hanldeKeydown.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.clear = this.clear.bind(this);
    }

    componentDidMount() {
        //console.log('Page loaded query: ' + query);
        this.trackSearchToGA(query, true);
    }

    autocomplete(evt) {
        let text = evt.target.value;

        if (text == "") {
            this.setState({ searchItems: [] });
            return;
        }

        const fetchSettings = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: "",
        };

        this.trackSearchToGA(text, false);

        fetch(`${episerver_AutoCompleteApiUrl}` + "?query=" + text + "&take=" + take + "&startPageContentReferenceString=" + startPageContentReferenceString, fetchSettings)
            .then(res => res.json())
            .then(data => {
                this.setState({ searchItems: data });
            });
    }

    trackSearchToGA(text, isPageLoad) {
        if (text.length >= minQuerytoTrack) {
            // Rewrite URL for copying conveniance
            window.history.pushState(null, null, window.location.href.split('?')[0] + '?query=' + text);
            console.log(window.location.href.split('?')[0] + '?query=' + text);

            if (isPageLoad) {
                console.log("Page Load. Query '" + text + "' not tracked. Tracking already done in autocomplete.");
            }
            else {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'search',
                    'searchTerm': text
                });

                console.log("Query '" + text + "' tracked");
                console.log('window.dataLayer: ' + window.dataLayer);
            }
        }
        else {
            // Clear URL from too short searh term
            if (window.location.href.indexOf('?query=') > 0) {
                window.history.pushState(null, null, window.location.href.split('?')[0]);
            }
        }
    }

    hanldeKeyup(evt) {
        if (evt.keyCode === 27) {
            this.setState({ cursor: -1, searchItems: [] });
            return false;
        }
    }

    hanldeKeydown(evt) {
        const { cursor, searchItems } = this.state;

        if (evt.keyCode === 38 && cursor > -1) {
            this.setState(prevState => ({
                cursor: prevState.cursor - 1
            }));
        } else if (evt.keyCode === 40 && cursor < searchItems.length - 1) {
            this.setState(prevState => ({
                cursor: prevState.cursor + 1
            }));
        }
        if (evt.keyCode === 9) {
            let currentItem = searchItems[cursor];
            if (currentItem !== undefined) {
                evt.preventDefault();

                const { name, } = currentItem;
                this.setState({ item: { name, }, cursor: -1, searchItems: [] });

                var elem = evt.target;
                elem.value = currentItem;
                elem.focus();

            }
        }
        if (evt.keyCode === 13) {
            let currentItem = searchItems[cursor];
            if (currentItem !== undefined) {
                const { name, } = currentItem;
                this.setState({ item: { name, }, cursor: -1, searchItems: [] });

                evt.target.value = currentItem;

                var parent = evt.target.parentElement;
                parent.querySelector(".searchButton").click();
            }
        }
    }

    selectItem(evt, titleSearch) {
        const { searchItems } = this.state;
        let selectedItem = searchItems.find(item => item === titleSearch);
        const { name } = selectedItem;
        this.setState({ item: { name }, cursor: -1, searchItems: [] });

        var parent = evt.target.closest(".icon-search")
        parent.querySelector(".query").value = titleSearch;
        parent.querySelector(".searchButton").click();
    }

    clear(evt) {
        var parent = evt.target.closest(".icon-search")
        parent.querySelector(".query").value = "";
    }

    render() {
        const { searchItems, cursor, item } = this.state;
        const { name } = item;

        return (
            <div className="icon-search">
                <div>
                    <input
                        type="search"
                        className="query"
                        name="query"
                        placeholder={placeHolder}
                        autoComplete="off"
                        onChange={this.autocomplete}
                        onKeyUp={this.hanldeKeyup}
                        onKeyDown={this.hanldeKeydown}
                        defaultValue={query}
                    />
                    <span className="icon-clear" onClick={this.clear}></span>
                </div>
                <button className="searchButton" type="submit" hidden>Search</button>
                {searchItems.length > 0 && (
                    <SearchItemsList
                        searchItems={searchItems}
                        cursor={cursor}
                        selectItem={this.selectItem}
                    />
                )}
            </div>
        );
    }
}

export default AutoCompleteView;